<template>
  <portal to="app-modal">
    <modal :name="name"
           :draggable="draggable"
           :pivotY="pivotY"
           :adaptive="true"
           :clickToClose="false"
           :height="'auto'"
           :scrollable="true"
           @closed="$emit('closed')"
    >
      <bs-card class="card-info" :label="label">
        <template v-slot:header>
          <bs-action :icon="['fas', 'times']" class="btn-info text-light" @click="$modal.hide(name)"></bs-action>
        </template>
        <slot></slot>
      </bs-card>
    </modal>
  </portal>
</template>

<script>
export default {
  name: 'BSModal',
  props: ['name', 'label'],
  computed: {
    draggable () {
      if (window.innerWidth > 768) return '.card-header'
      return false
    },
    pivotY () {
      if (window.innerWidth <= 768) return 0
      return 0.5
    }
  }
}
</script>

<style lang="scss">
.v--modal-overlay .v--modal-box {
  overflow: visible!important;
}
</style>
